import { DateTimeRenderer } from '../../../components/AgGrid/renderers'
import React from 'react'

const NoEntryIntoTheUsageUnitWithoutEquipmentAppointmentAccessDateRenderer = (
  props
) => {
  const { value } = props
  if (!value || !value.length > 0) {
    return ''
  }
  return <DateTimeRenderer value={value[0].executionDate} />
}

export default NoEntryIntoTheUsageUnitWithoutEquipmentAppointmentAccessDateRenderer
